export default "__VITE_ASSET__32863887__"